import moment from 'moment-timezone';

export function getCurrentDate(){
    return `${new Date().toISOString() + ""}`;
}

export function reformattedDate(calender_date) {
    // convert 2024-12-30 to Dec 30, 2024
    return moment(calender_date).format("MMM D, YYYY");
}